import $ from 'jquery';

class AnchorLinks {
  constructor() {
    this.hash = window.location.hash;
    this.header = $('.js-header');

    this.smoothScroll();
  }

  smoothScroll() {
    if (this.hash.length) {
      const anchor = $(this.hash);

      if (anchor.length) {
        $('body, html')
          .stop()
          .animate(
            {
              scrollTop: anchor.offset().top - this.header.outerHeight(),
            },
            400,
          );
      }
    }
  }
}

export default new AnchorLinks();



// WEBPACK FOOTER //
// ./src/scripts/modules/anchor-links.js